import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const InformationModal = ({ visible, onHide, onApprove }) => {

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header="Aydınlatma Metni ve Hizmet Koşulları"
            style={{ width: '95vw', maxWidth: '800px', height: '95vh' }}
            className="information-modal"
            modal
            closable={true}
            resizable={false}
        >
            <div
                className="information-content"
                style={{
                    height: 'calc(95vh - 200px)',
                    maxHeight: 'calc(95vh - 200px)',
                    overflowY: 'auto',
                    padding: '1rem 0',
                    marginBottom: '1rem'
                }}
            >
                <div className="prose prose-sm">
                    {/* Tüm içerik aynı kalıyor */}
                    <h2 className="font-bold text-lg mb-4">AYDINLATMA METNİ VE HİZMET KOŞULLARI</h2>

                    <h3 className="font-bold text-md mb-3">1. HİZMET KAPSAMI VE TANIMI</h3>
                    <p className="mb-4">
                        PayPlus, elektronik ödeme sistemleri, para transferi, ödeme aracılığı ve finansal teknoloji
                        hizmetleri sunan bir platformdur. Bu aydınlatma metni, sunduğumuz hizmetlerin kapsamı,
                        kullanım koşulları ve karşılıklı yükümlülükleri açıklamaktadır.
                    </p>

                    <h3 className="font-bold text-md mb-3">2. HİZMET TÜRLERİ VE ÖZELLİKLERİ</h3>
                    <p className="mb-3">PayPlus platformu aracılığıyla sunulan hizmetler:</p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li><strong>Kullanıcı Yönetim Modülü:</strong> Kayıt, hesap yönetimi ve kullanıcı yetkilendirme</li>
                        <li><strong>Müşteri Yönetim Modülü:</strong> Müşteri verisi ekleme, güncelleme ve arşivleme</li>
                        <li><strong>Kefil Yönetim Modülü:</strong> Kefil bilgisi düzenleme ve ilişkilendirme</li>
                        <li><strong>Senet Oluşturma Modülü:</strong> Senet oluşturma, ödeme planı tanımlama ve düzenleme</li>
                        <li><strong>Ödeme Takip ve Raporlama Modülü:</strong> Ödeme süreçlerinin takibi, raporlanması ve otomatik bildirim gönderimi</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">3. ÜCRETLENDİRME POLİTİKASI</h3>
                    <p className="mb-4">
                        Hizmetlerimiz için uygulanan ücretlendirme politikası aşağıdaki esaslara dayanır:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>İşlem türüne göre değişken komisyon oranları</li>
                        <li>Aylık işlem hacmine dayalı indirimli tarifeler</li>
                        <li>Kurumsal müşteriler için özel fiyatlandırma</li>
                        <li>Güncel ücret tarifeleri web sitesinde yayınlanır</li>
                        <li>Ücret değişiklikleri 30 gün önceden duyurulur</li>
                        <li>Bazı temel hizmetler ücretsiz olarak sunulabilir</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">4. KULLANICI SORUMLULUKLARI VE YÜKÜMLÜLÜKLER</h3>
                    <p className="mb-3">Platform kullanıcıları olarak aşağıdaki yükümlülükleri kabul edersiniz:</p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Doğru, eksiksiz ve güncel bilgi sağlama</li>
                        <li>Hesap güvenliğini koruma ve yetkisiz erişimi engelleme</li>
                        <li>Yasalara uygun işlemler gerçekleştirme</li>
                        <li>Sahte, hileli veya yanıltıcı işlem yapmama</li>
                        <li>Platform güvenliğini tehlikeye atacak eylemlerden kaçınma</li>
                        <li>Fikri mülkiyet haklarına saygı gösterme</li>
                        <li>Şüpheli işlemleri derhal bildirme</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">5. GÜVENLİK ÖNLEMLERİ VE RİSK YÖNETİMİ</h3>
                    <p className="mb-4">
                        Platform güvenliği için aşağıdaki önlemler alınmıştır:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>256-bit SSL şifreleme teknolojisi</li>
                        <li>Çok faktörlü kimlik doğrulama (2FA)</li>
                        <li>7/24 güvenlik izleme ve analiz</li>
                        <li>Düzenli penetrasyon testleri</li>
                        <li>PCI DSS uyumlu altyapı</li>
                        <li>Fraud önleme sistemleri</li>
                        <li>Risk tabanlı işlem analizi</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">6. İPTAL VE İADE KOŞULLARI</h3>
                    <p className="mb-4">
                        İşlem iptali ve iade işlemleri aşağıdaki koşullara tabidir:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Henüz gerçekleşmemiş işlemler iptal edilebilir</li>
                        <li>Tamamlanmış işlemler için iade süreci başlatılabilir</li>
                        <li>İade süreleri işlem türüne göre 3-10 iş günü arası değişir</li>
                        <li>Hatalı işlemler için anında düzeltme sağlanır</li>
                        <li>Ücret iadesi işlemler iptal durumunda otomatik yapılır</li>
                        <li>Anlaşmazlık durumunda tahkim süreci başlatılabilir</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">7. HİZMET KESİNTİLERİ VE BAKIM</h3>
                    <p className="mb-4">
                        Sistem bakım ve güncelleme durumları:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Planlanmış bakım çalışmaları önceden duyurulur</li>
                        <li>Acil müdahaleler derhal gerçekleştirilir</li>
                        <li>Hizmet kesintileri minimize edilmeye çalışılır</li>
                        <li>Sistem durumu anlık olarak izlenebilir</li>
                        <li>Alternatif erişim yöntemleri sağlanabilir</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">8. SINIRLI GARANTİ VE SORUMLULUK</h3>
                    <p className="mb-4">
                        PayPlus'ın sorumluluk sınırları:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Hizmetler "olduğu gibi" sunulmaktadır</li>
                        <li>Teknik arızalardan kaynaklanan gecikmeler</li>
                        <li>Üçüncü taraf hizmet sağlayıcı sorunları</li>
                        <li>Force majeure (mücbir sebep) durumları</li>
                        <li>İnternet bağlantısı ve altyapı sorunları</li>
                        <li>Kullanıcı hatası kaynaklı işlem hataları</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">9. UYUŞMAZLIK ÇÖZÜMÜ</h3>
                    <p className="mb-4">
                        Hizmetlerimizle ilgili uyuşmazlıkların çözümü:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Öncelikle müşteri hizmetleri ile iletişim</li>
                        <li>Arabuluculuk ve uzlaşma süreçleri</li>
                        <li>Türkiye Cumhuriyeti mahkemeleri yetkili</li>
                        <li>Zonguldak mahkemeleri ve icra daireleri yetkili</li>
                        <li>Tüketici hakları korunur</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">10. MEVZUAT UYUMU VE DENETİM</h3>
                    <p className="mb-4">
                        PayPlus aşağıdaki mevzuat ve standartlara uyar:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>6493 sayılı Ödeme ve Menkul Kıymet Mutabakat Sistemleri Kanunu</li>
                        <li>TCMB Ödeme Hizmetleri Yönetmeliği</li>
                        <li>SPK mevzuatı</li>
                        <li>MASAK düzenlemeleri</li>
                        <li>Kişisel Verilerin Korunması Kanunu</li>
                        <li>PCI DSS güvenlik standartları</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">11. İLETİŞİM VE MÜŞTERİ HİZMETLERİ</h3>
                    <p className="mb-4">
                        Sorularınız ve destek talepleriniz için:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>7/24 Çağrı Merkezi: +90 (532) 599 98 67</li>
                        <li>E-posta: info@payplus.com.tr</li>
                        <li>Canlı Destek: Web sitesi ve mobil uygulama</li>
                        <li>Şikayet hattı: info@payplus.com.tr</li>
                        <li>Whatsapp Destek: +90 (532) 599 98 67</li>
                    </ul>

                    <div className="bg-purple-50 p-4 rounded-lg mt-6">
                        <p className="text-sm text-purple-800">
                            <strong>Önemli Bilgilendirme:</strong> Bu aydınlatma metni, PayPlus hizmetlerinin
                            kullanımına ilişkin temel bilgileri içermektedir. Detaylı şartlar için web sitemizdeki
                            tam sözleşme metnini inceleyiniz. Bu metin, yasal düzenlemeler doğrultusunda
                            güncellenebilir ve değişiklikler size bildirilir.
                        </p>
                    </div>

                    <div className="bg-red-50 p-4 rounded-lg mt-4 mb-6">
                        <p className="text-sm text-red-800">
                            <strong>Risk Uyarısı:</strong> Elektronik ödeme işlemlerinde dikkatli olunuz.
                            Şüpheli işlemler derhal bildirilmelidir. PayPlus güvenlik önlemleri alsa da,
                            kullanıcı sorumluluklarını yerine getirmelidir.
                        </p>
                    </div>
                </div>
            </div>

            <div
                className="flex justify-end gap-3 mt-4 pt-4 border-t bg-white sticky bottom-0"
                style={{
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'white',
                    borderTop: '1px solid #e5e7eb',
                    paddingTop: '1rem',
                    marginTop: '1rem'
                }}
            >
                <Button
                    label="İptal"
                    className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm"
                    onClick={onHide}
                />
                <Button
                    label="Okudum ve Onaylıyorum"
                    className="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg text-sm"
                    onClick={() => {
                        onApprove();
                        onHide();
                    }}
                />
            </div>
        </Dialog>
    );
};

export default InformationModal;